import React, { useEffect } from "react";
import styles from "../../styles/layout/memberpartner-dashboard-wrapper.module.scss";
import { Box, Stack } from "@mui/material";
import MemberPartnerDashboardHeader from "../Header/MemberPartnerDashboardHeader";
import MemberPartnerDashboardSidebar from "../Sidebar/MemberPartnerDashboardSidebar";
import UserCopyWriterFooter from "../UserFooter/UserCopyWriterFooter";
import { parseCookies } from "nookies";
import { useNavigate } from "react-router";

const MemberPartnerDashboardWrapper = (props) => {
  const cookies = parseCookies();
  const savedrole_Id = cookies?.role_id;
  const { tabId } = props;
  console.log("wrapper", tabId);

  const nav = useNavigate();

  useEffect(() => {
    if (savedrole_Id != 2 && savedrole_Id != 3) {
      //   <Navigate to="/page404" />;
      // nav("/page404");
      nav("/login");
    }
  }, [savedrole_Id]);

  return (
    <>
      <MemberPartnerDashboardHeader />
      <Stack direction={"row"} className={styles.editorDashboardSiderbarBody}>
        <Box className={styles.editorDashboardSidebar}>
          <MemberPartnerDashboardSidebar />
        </Box>
        <Box className={styles.editorDashboardBody}>{props.children}</Box>
      </Stack>
      <UserCopyWriterFooter footerChatBtn={props.chatbtn} />
    </>
  );
};

export default MemberPartnerDashboardWrapper;
